import { BannerContext } from '../components/Providers/Banner'
import React from 'react'
import useLocation from 'react-use/lib/useLocation'

/**
 * useBanner is a hook that returns the banner text, the CTA text, the CTA link along with the
 * banner ref to manipulate the banner behavior as and when needed and the `showBanner` boolean
 * to show/hide the banner.
 * @returns The banner data
 */
export default function useBanner(): {
  showBanner: boolean
  bannerRef: React.RefObject<HTMLDivElement>
  bannerText: string
  bannerCtaLink: string
  bannerCtaText: string
} {
  let showBanner = false
  const bannerRef = React.useRef<HTMLDivElement>(null)
  const {
    banner_text: bannerText,
    banner_cta_text: bannerCtaText,
    banner_cta_link: bannerCtaLink,
  } = React.useContext(BannerContext)
  const { pathname } = useLocation()

  if (bannerText && bannerCtaLink && !(pathname === bannerCtaLink)) {
    showBanner = true
  }

  return {
    showBanner,
    bannerRef,
    bannerText,
    bannerCtaLink,
    bannerCtaText,
  }
}
